// A small chip to another part of Zuzu, from an AI chat: under the reply that
// mentioned it (opens in a new tab, so the chat stays), or on the end card.
import { Link } from 'react-router-dom';
import { API_BASE } from '../lib/config';
import { CHAT_HOUR_PATH, liveSession, nextSession, timeIn } from '../content/chatHour';

export type NudgeTo = 'letgo' | 'sky' | 'chatHour';

function chipFor(to: NudgeTo, short: boolean) {
  if (to === 'letgo') return { emoji: '🍃', label: short ? 'Let Go' : 'Let Go a thought', href: '/let-go' };
  if (to === 'sky') return { emoji: '✨', label: 'Sky of Thoughts', href: '/sky-of-thoughts' };
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return {
    emoji: '⏳💬',
    label: liveSession() ? 'Chat Hour is on now' : `Chat Hour at ${timeIn(nextSession().start, tz)}`,
    href: CHAT_HOUR_PATH,
  };
}

export default function NudgeChip({ to, where, isNight, onGo }: { to: NudgeTo; where: 'chat' | 'end'; isNight: boolean; onGo?: () => void }) {
  const { emoji, label, href } = chipFor(to, where === 'end');
  const tap = () => {
    fetch(`${API_BASE}/api/chat/nudge-tap`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ to, where }) }).catch(() => {});
    onGo?.();
  };
  const className = `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[0.75rem] border transition-colors ${
    isNight ? 'border-white/15 text-white/75 hover:bg-white/10' : 'border-black/10 text-black/70 hover:bg-black/5'
  }`;
  const body = <><span aria-hidden="true">{emoji}</span>{label}</>;
  return where === 'chat'
    ? <a href={href} target="_blank" rel="noopener" onClick={tap} className={className}>{body}</a>
    : <Link to={href} onClick={tap} className={className}>{body}</Link>;
}
